import { View, Text, Platform } from "react-native";
import { GuidePageHeader, GuideStep, GuideTip, GuideCard, GuideNav, getGuideNav } from "./_components";

const PAGE_HREF = "/(web)/guide/getting-started";

export default function GettingStartedPage() {
  if (Platform.OS !== "web") return null;
  const nav = getGuideNav(PAGE_HREF);

  return (
    <View>
      <GuidePageHeader
        icon="rocket"
        title="Aan de Slag"
        subtitle="Download de app, maak je account aan en ontdek wat de Staatsen Familie App te bieden heeft."
        color="#7C3AED"
      />

      {/* Stap voor stap */}
      <Text className="text-xl font-bold text-gray-900 mb-4">Account aanmaken</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        De Staatsen Familie App is exclusief voor familieleden. Je hebt een uitnodiging nodig om 
        een account aan te maken. Volg deze stappen om te beginnen:
      </Text>

      <View className="mb-8">
        <GuideStep
          step={1}
          title="Download de app"
          description="Download de Staatsen Familie App vanuit de App Store (iPhone) of Google Play Store (Android). Zoek op 'Staatsen' of gebruik de link die je hebt ontvangen."
        />
        <GuideStep
          step={2}
          title="Open de app en kies 'Account aanmaken'"
          description="Op het welkomstscherm kun je kiezen tussen inloggen of een nieuw account aanmaken. Kies 'Account aanmaken' als je voor het eerst de app gebruikt."
        />
        <GuideStep
          step={3}
          title="Vul je gegevens in"
          description="Voer je e-mailadres, naam en een wachtwoord in. Gebruik bij voorkeur je echte naam zodat familieleden je kunnen herkennen."
        />
        <GuideStep
          step={4}
          title="Profiel voltooien"
          description="Voeg een profielfoto toe en vul je bijnaam in. Dit is hoe je zichtbaar bent voor andere familieleden in de app."
        />
        <GuideStep
          step={5}
          title="Klaar!"
          description="Je kunt nu de app gebruiken! Bekijk het startscherm, chat met familieleden en ontdek alle functies."
        />
      </View>

      <GuideTip title="Uitnodiging nodig">
        Je kunt alleen een account aanmaken als je bent uitgenodigd door een admin van de familie. 
        Heb je geen uitnodiging ontvangen? Neem contact op met de commissie.
      </GuideTip>

      {/* Het startscherm */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Het Startscherm</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        Na het inloggen kom je op het startscherm. Dit is je centrale plek in de app. Van hieruit 
        kun je alles bereiken:
      </Text>

      <View className="mb-6">
        <GuideCard
          icon="home"
          title="Dashboard"
          description="Het startscherm toont een overzicht van het actieve weekend, je team, recente activiteiten en snelkoppelingen naar alle functies."
          color="#7C3AED"
        />
        <GuideCard
          icon="chatbubbles"
          title="Chat"
          description="Onderin de app vind je de chat-tab. Hier kun je met familieleden praten in groepschats, team-chats en privéberichten."
          color="#6366F1"
        />
        <GuideCard
          icon="game-controller"
          title="Spellen"
          description="De spellen-tab biedt toegang tot alle beschikbare spellen. Speel solo of daag familieleden uit!"
          color="#3B82F6"
        />
        <GuideCard
          icon="people"
          title="Teams"
          description="Bekijk je team, je teamgenoten en de teamstand. Pas je teamavatar aan en bekijk de scores."
          color="#EC4899"
        />
        <GuideCard
          icon="person"
          title="Profiel"
          description="Beheer je profiel, instellingen en meldingsvoorkeuren vanuit de profiel-tab."
          color="#10B981"
        />
      </View>

      {/* Navigatie-balk */}
      <Text className="text-xl font-bold text-gray-900 mb-4">Navigatie</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        Onderin de app vind je de navigatiebalk met vijf tabbladen: Home, Chat, Spellen, Teams en 
        Profiel. Tik op een tabblad om naar dat gedeelte te gaan. Het huidige tabblad is gemarkeerd 
        met de primaire kleur van de app.
      </Text>

      <GuideTip variant="success" icon="checkmark-circle" title="Tip">
        Trek het scherm naar beneden (pull-to-refresh) om de nieuwste gegevens op te halen op de 
        meeste schermen in de app.
      </GuideTip>

      {/* Kinderen / Afhankelijken */}
      <Text className="text-xl font-bold text-gray-900 mb-4 mt-8">Kinderen toevoegen</Text>
      <Text className="text-base text-gray-600 leading-6 mb-6">
        Hebben jullie jonge kinderen die nog geen eigen account kunnen beheren? Een super admin 
        kan een "afhankelijk profiel" aanmaken. Als ouder of voogd kun je vervolgens wisselen naar 
        het profiel van je kind om namens hen te spelen, te chatten en punten te verdienen.
      </Text>

      <GuideTip icon="swap-horizontal" title="Profiel wisselen">
        Ga naar je profiel en tik op "Wissel naar..." om over te schakelen naar het profiel van 
        je kind. Je ziet bovenin een banner dat je speelt als een ander profiel.
      </GuideTip>

      <GuideNav {...nav} />
    </View>
  );
}
